<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/10/2021
  -->

<template>
	<qw-dropdown
		v-if="splitButton"
		:options="splitDropdownOptions"
		:primaryOption="primaryOption"
		v-bind="splitDropdownAttrs"
		@click="onOptionClicked">
		<slot>{{ primaryOptionLabel }}</slot>
	</qw-dropdown>
	<qw-dropdown
		v-else
		:options="options"
		v-bind="$attrs"
		@click="onOptionClicked">
		<template #trigger>
			<slot name="trigger">
				<qw-button v-bind="buttonAttrs">
					<slot>{{ buttonText }}</slot>
					<slot name="icon"><i class="fontello icon-angle-down ml-1 font-size-4"/></slot>
				</qw-button>
			</slot>
		</template>
	</qw-dropdown>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import QwDropdown from "@/core/components/Controls/Buttons/QwDropdown.vue";

export default {
	name: "QwDropdownButton",
	components: {QwDropdown},
	extends: BaseComponent,
	inheritAttrs: false,
	emits: ["click"],
	props: {
		buttonText: {String, default: "Click"},
		options: {Array, required: true},
		splitButton: Boolean,
	},

	computed: {
		buttonAttrs() {
			let attrs = {}
			Object.keys(this.$attrs).forEach(key => {
				if(key.startsWith("button-")){
					let buttonKey = key.replace("button-", "")
					attrs[buttonKey] = this.$attrs[key]
				}
			})
			return attrs
		},

		splitDropdownOptions() {
			return this.options.slice(1)
		},

		primaryOption() {
			return this.options[0] || null
		},

		primaryOptionLabel() {
			return this.primaryOption?.[this.labelKey] || this.buttonText
		},

		labelKey() {
			return this.$attrs["label-key"] || this.$attrs.labelKey || "label"
		},

		splitDropdownAttrs() {
			let attrs = {}
			Object.keys(this.$attrs).forEach(key => {
				if(!key.startsWith("button-")){
					attrs[key] = this.$attrs[key]
				}
			})
			attrs.splitButton = true
			if(attrs.type === undefined && this.$attrs["button-type"] !== undefined){
				attrs.type = this.$attrs["button-type"]
			}
			if(attrs.size === undefined && this.$attrs["button-size"] !== undefined){
				attrs.size = this.$attrs["button-size"]
			}
			return attrs
		},
	},

	methods: {
		onOptionClicked(option) {
			this.$emit("click", option)
		},
	},
}
</script>

<style lang="scss">

</style>
